module.exports = __webpack_public_path__ + "media/images/pregunta-6a61dceac7e2eae2eed870c49014950d.svg";